import type Vue from 'vue'

import type { ErrorHandler } from '@/common/lib/error-handlers/error-handler'

/**
 * Handle HTTP 404 error
 */
const handleNotFound: ErrorHandler = async (vue: Vue): Promise<void> => {
    await vue.$router.replace({ name: '404' })
}

export { handleNotFound }
